import React, { useEffect, useState } from "react"
import ApexCharts from "react-apexcharts"
import useFetchSettings from "../../hooks/useFetchSettings"

const ExpectedPatientsBarchart = ({ expectedPatientsData }) => {
	const [filteredData, setFilteredData] = useState([])

	const { settingsData } = useFetchSettings()

	// Convert time (e.g., '15:20') into '3:20 PM' format for the x-axis labels
	const convertTo12HourFormat = time => {
		let [hour, minute] = time.split(":").map(Number)
		const ampm = hour >= 12 ? "PM" : "AM"
		hour = hour % 12 || 12 // Convert to 12-hour format, handling noon and midnight
		return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`
	}

	useEffect(() => {
		// Filter data to only include entries with times that are at 00 or 30 minutes
		const filtered = expectedPatientsData.filter(item => {
			const [, minutes] = item.time.split(":").map(Number)
			return minutes === 0 || minutes === 30
		})
		setFilteredData(filtered)
	}, [expectedPatientsData])

	const options = {
		chart: {
			type: "bar",
			height: 350,
			stacked: false,
			toolbar: {
				show: false
			},
			fontFamily: "Manrope, sans-serif"
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: "50%",
				borderRadius: 3 // Rounded corners
			}
		},
		xaxis: {
			categories: filteredData.map(item => convertTo12HourFormat(item.time)),
			labels: {
				style: {
					fontFamily: "Manrope, sans-serif",
					fontSize: "12px"
				}
			}
		},
		yaxis: {
			title: {
				text: "Expected Patients",
				style: {
					fontFamily: "Manrope, sans-serif",
					fontSize: "12px"
				}
			}
			// max: Math.max(maxExpectedPatients, settingsData?.numberOfChairs) + 5, // Ensure the y-axis max is higher than the max value
			// min: 0
		},
		colors: ["#6955EA"], // Use a single color for expected patients
		dataLabels: {
			enabled: false // Disable data labels
		},
		grid: {
			borderColor: "#f1f1f1"
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val + " patients"
				}
			}
		},
		legend: {
			show: false // No legend needed for a single series
		}
		// annotations: {
		// 	yaxis: [
		// 		{
		// 			y: settingsData?.numberOfChairs,
		// 			borderColor: "#081B5B", // Line color matching the design
		// 			strokeDashArray: 0, // Solid line
		// 			label: {
		// 				borderColor: "#081B5B",
		// 				borderRadius: 15, // Rounded edges for the label
		// 				style: {
		// 					color: "#fff", // White text
		// 					background: "#081B5B", // Dark blue background
		// 					fontSize: "10px", // Adjust font size if needed
		// 					padding: {
		// 						left: 15,
		// 						right: 15,
		// 						top: 4,
		// 						bottom: 5
		// 					}
		// 				},
		// 				text: "Max Capacity", // Text inside the label
		// 				offsetX: -10, // Optional: offset horizontally to adjust position
		// 				offsetY: 6 // Optional: offset horizontally to adjust position
		// 			}
		// 		}
		// 	]
		// }
	}

	const series = [
		{
			name: "Expected Patients",
			data: filteredData.map(item => item.expectedPatients)
		}
	]

	if (!settingsData) {
		return null
	}

	return (
		<div className="w-full p-4">
			<div className="bg-white rounded-lg shadow-md font-sans">
				<h5 className="text-xl font-bold leading-none text-gray-900 mb-3">
					Template Utilization
				</h5>
				<div className="p-6">
					<ApexCharts options={options} series={series} type="bar" height={350} />
				</div>
			</div>
		</div>
	)
}

export default ExpectedPatientsBarchart
